export const fetchAll = {
  pathname: () => '/notificationJobs',
}

export const createNotificationJob = {
  pathname: () => '/notificationJobs',
  method: 'POST',
  body: (body) => (body)
}

export const remove = {
  pathname: ({ id }) => `/notificationJobs/${id}`,
  method: 'DELETE',
}

export const update = {
  pathname: ({ id }) => `/notificationJobs/${id}`,
  method: 'PATCH',
  body: ({ payload }) => ({ ...payload })
}
